// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1XrES","content":"Consent_content__1I23x","footer":"Consent_footer__uGP3_"};